(function() {
  'use strict';

  var cachedPromise = null;

  function load() {
    if (cachedPromise) return cachedPromise;

    var url = (window.CoberturaEntregaUrl || '/cdn/shop/t/1/assets/cobertura-entrega.json');

    cachedPromise = fetch(url, { credentials: 'omit' })
      .then(function(response) {
        if (!response.ok) {
          throw new Error('HTTP ' + response.status);
        }
        return response.json();
      })
      .catch(function(err) {
        // Reset cache so next call retries instead of returning the failed promise
        cachedPromise = null;
        throw err;
      });

    return cachedPromise;
  }

  function clearCache() {
    cachedPromise = null;
  }

  window.CoberturaEntrega = {
    load: load,
    clearCache: clearCache
  };
})();